import { TFunction } from "next-i18next";

import { mergeContent } from "utils/mergeContent";
import { PageContentProps } from "content/content.types";

import defaultContent from "./common";

const pageContent: any = (t: TFunction, pageContent: PageContentProps) => {
    const content = defaultContent(t, pageContent);

    return mergeContent(content, {
        content: {
            subtitle: t("universalForm:subtitle"),
        },
    });
};

export default pageContent;
